module.exports = __webpack_public_path__ + "static/media/cert_114.f0fe5491.jpg";